import { SVGFC } from '@repo/toolkit/types'

const XThreeIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15969_25883)">
        <path
          d="M11 1.5C5.48154 1.5 1 5.98154 1 11.5C1 17.0185 5.48154 21.5 11 21.5C16.5185 21.5 21 17.0185 21 11.5C21 5.98154 16.5185 1.5 11 1.5ZM11 2.27077C16.1023 2.27077 20.2308 6.39769 20.2308 11.5C20.2308 16.6023 16.1023 20.7308 11 20.7308C5.89769 20.7308 1.76923 16.6023 1.76923 11.5C1.76923 6.39769 5.89769 2.27077 11 2.27077ZM11 6.49692C10.3432 6.49624 9.69267 6.62542 9.08593 6.87704C8.4792 7.12866 7.9282 7.49775 7.46462 7.96308C6.99896 8.42681 6.62957 8.97803 6.37769 9.58502C6.12581 10.192 5.99641 10.8428 5.99692 11.5C5.99653 12.1569 6.12599 12.8075 6.37787 13.4142C6.62975 14.0209 6.99908 14.5719 7.46462 15.0354C7.92844 15.5005 8.47947 15.8694 9.08613 16.1212C9.69279 16.373 10.3432 16.5026 11 16.5026C11.6568 16.5026 12.3072 16.373 12.9139 16.1212C13.5205 15.8694 14.0716 15.5005 14.5354 15.0354C15.0004 14.5714 15.3694 14.0202 15.6211 13.4134C15.8728 12.8066 16.0024 12.1562 16.0024 11.4992C16.0024 10.8423 15.8728 10.1918 15.6211 9.58504C15.3694 8.97826 15.0004 8.42708 14.5354 7.96308C14.0718 7.49775 13.5208 7.12866 12.9141 6.87704C12.3073 6.62542 11.6568 6.49624 11 6.49692ZM12.8977 9.20462C13.2062 9.19462 13.3992 9.65308 13.1754 9.86692L11.5438 11.4985L13.1754 13.13C13.47 13.4131 12.9138 13.9685 12.6315 13.6738L10.9985 12.0431L9.36692 13.6738C9.08462 13.9685 8.52846 13.4123 8.82308 13.13L10.4546 11.4985L8.82308 9.86692C8.60385 9.65462 8.78692 9.20538 9.09231 9.20538C9.19462 9.20615 9.29538 9.24923 9.36692 9.32308L10.9985 10.9546L12.6315 9.32308C12.6655 9.28713 12.7062 9.25829 12.7513 9.23822C12.7965 9.21815 12.8452 9.20725 12.8946 9.20615H12.8977V9.20462Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_15969_25883">
          <rect width="20" height="20" fill={color} transform="translate(1 1.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default XThreeIcon
